"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlMessageType = void 0;

var UnsupportedVersionError_1 = __importDefault(require("../../errors/UnsupportedVersionError"));

var UnsupportedTypeError_1 = __importDefault(require("../../errors/UnsupportedTypeError"));

var validations_1 = require("../../utils/validations"); // TODO use ControlMessageType instead of number when we have real enums


var serializerByVersionAndType = {};
var LATEST_VERSION = 2;
var ControlMessageType;

(function (ControlMessageType) {
  ControlMessageType[ControlMessageType["BroadcastMessage"] = 0] = "BroadcastMessage";
  ControlMessageType[ControlMessageType["ErrorResponse"] = 7] = "ErrorResponse";
  ControlMessageType[ControlMessageType["UnsubscribeRequest"] = 10] = "UnsubscribeRequest";
  ControlMessageType[ControlMessageType["PublishStreamConnectionRequest"] = 14] = "PublishStreamConnectionRequest";
  ControlMessageType[ControlMessageType["PublishStreamConnectionResponse"] = 15] = "PublishStreamConnectionResponse";
})(ControlMessageType = exports.ControlMessageType || (exports.ControlMessageType = {}));

var ControlMessage = /*#__PURE__*/function () {
  function ControlMessage() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LATEST_VERSION;
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var requestId = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ControlMessage);

    if ((this instanceof ControlMessage ? this.constructor : void 0) === ControlMessage) {
      throw new TypeError('ControlMessage is abstract.');
    }

    (0, validations_1.validateIsInteger)('version', version);
    this.version = version;
    (0, validations_1.validateIsInteger)('type', type);
    this.type = type; // Since V2 - allow null in older versions

    (0, validations_1.validateIsString)('requestId', requestId, version < 2);
    this.requestId = requestId;
  }

  _createClass(ControlMessage, [{
    key: "serialize",
    value: function serialize() {
      var _ControlMessage$getSe;

      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.version;

      for (var _len = arguments.length, typeSpecificSerializeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        typeSpecificSerializeArgs[_key - 1] = arguments[_key];
      }

      return JSON.stringify((_ControlMessage$getSe = ControlMessage.getSerializer(version, this.type)).toArray.apply(_ControlMessage$getSe, [this].concat(typeSpecificSerializeArgs)));
    }
    /**
     * Takes a serialized representation (array or string) of a message, and returns a ControlMessage instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }], [{
    key: "registerSerializer",
    value: function registerSerializer(version, type, serializer) {
      // Check the serializer interface
      if (!serializer.fromArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method fromArray!"));
      }

      if (!serializer.toArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method toArray!"));
      }

      if (serializerByVersionAndType[version] === undefined) {
        serializerByVersionAndType[version] = {};
      }

      if (serializerByVersionAndType[version][type] !== undefined) {
        throw new Error("Serializer for version ".concat(version, " and type ").concat(type, " is already registered: ").concat(JSON.stringify(serializerByVersionAndType[version][type])));
      }

      serializerByVersionAndType[version][type] = serializer;
    }
  }, {
    key: "unregisterSerializer",
    value: function unregisterSerializer(version, type) {
      delete serializerByVersionAndType[version][type];
    }
  }, {
    key: "getSerializer",
    value: function getSerializer(version, type) {
      var serializersByType = serializerByVersionAndType[version];

      if (!serializersByType) {
        throw new UnsupportedVersionError_1.default(version, "Supported versions: [".concat(ControlMessage.getSupportedVersions(), "]"));
      }

      var clazz = serializersByType[type];

      if (!clazz) {
        throw new UnsupportedTypeError_1.default(type, "Supported types: [".concat(Object.keys(serializersByType), "]"));
      }

      return clazz;
    }
  }, {
    key: "getSupportedVersions",
    value: function getSupportedVersions() {
      return Object.keys(serializerByVersionAndType).map(function (key) {
        return parseInt(key, 10);
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize(msg) {
      var messageArray = typeof msg === 'string' ? JSON.parse(msg) : msg;
      /* eslint-disable prefer-destructuring */

      var messageVersion = messageArray[0];
      var messageType = messageArray[1];
      /* eslint-enable prefer-destructuring */

      var C = ControlMessage.getSerializer(messageVersion, messageType);

      for (var _len2 = arguments.length, typeSpecificDeserializeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        typeSpecificDeserializeArgs[_key2 - 1] = arguments[_key2];
      }

      return C.fromArray.apply(C, [messageArray].concat(typeSpecificDeserializeArgs));
    }
  }]);

  return ControlMessage;
}();

exports.default = ControlMessage;
ControlMessage.LATEST_VERSION = LATEST_VERSION;
ControlMessage.TYPES = ControlMessageType; // TODO can we remove this and use the enum object directly?